import script from "./UiDateIntervalSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDateIntervalSelect.vue?vue&type=script&setup=true&lang=js"

import "./UiDateIntervalSelect.vue?vue&type=style&index=0&id=6a5f8314&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a5f8314"]])

export default __exports__